import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';


import {environment} from './environments/environment';
import { ServerApi } from './app/services/api.services/server.api';
import { SessionApiSvc } from './app/services/api.services/session.api.svc';
import { SseApiSvc } from './app/services/api.services/SSE/sse.api.svc';
import { PlacemarksApiSvc } from './app/services/api.services/placemarks.api.svc';
import { SitesApiSvc } from './app/services/api.services/sites.api.svc';
import { Models3DApiSvc } from './app/services/api.services/models.3D.api.svc';
import { Models2DApiSvc } from './app/services/api.services/models.2D.api.svc';
import { FilesApiSvc } from './app/services/api.services/files.api.svc';
import { LayersApiSvc } from './app/services/api.services/layers.api.svc';
import { ZonesApiSvc } from './app/services/api.services/zones.api.svc';
import { ViewpointsApiSvc } from './app/services/api.services/viewpoints.api.svc';
import { TourApiSvc } from './app/services/api.services/tour.api.svc';
import { DiscussionApiSvc } from './app/services/api.services/discussion.api.svc';
import { ImportExportApiSvc } from './app/services/api.services/import.export.api.svc';
import { SearchApiSvc } from './app/services/api.services/search.api.svc';
import { PermissionApiSvc } from './app/services/api.services/permission.api.svc';
import { ScansApiSvc } from './app/services/api.services/scans.api.svc';
import { WebshareApiSvc } from './app/services/api.services/webshare.api.svc';
import { WebshareLoginApiSvc } from './app/services/api.services/webshare.login.api.svc';
import { DispatcherSseApiSvc } from './app/services/api.services/dispatcher.sse.api.svc';
import { TemplateManagementApiSvc } from './app/services/api.services/template.management.api.svc';
import { DataPrivacyApiSvc } from './app/services/api.services/data-privacy.api.svc';
import { MoveObjectApiSvc } from './app/services/api.services/move-object.api.svc';
import { BackgroundOperationsApiSvc } from './app/services/api.services/background.operations.api.svc';
import { ThemeService } from './app/services/themes.service';
import { DownloadFileHelper } from './app/services/download.file.helper';
import { SvgIconsService } from './app/services/svg-icons.service';
import { DialogService } from './app/services/dialogs.service';
import { DialogComSvc } from './app/services/modeless-com.service';
import { ObjectSiteValidatorService } from './app/services/object-site-validator.service';
import { Validators } from './app/common/Validators/validators';
import { LayersStateUtils } from './app/Store/layers.state/layers.state.utils';
import { CmdRouterService } from './app/services/cmd-router.service';
import { SitesUtils } from './app/Store/sites.state/sites.utils';
import { LibIconsService } from './app/services/lib-icons.service';
import { UserDetailsService } from './app/services/user-details.service';
import { PlacemarkPreviewService } from './app/services/placemark-preview.service';
import { ContainersHelper } from './app/Viewer/content.container/scene.container/webgl-container/containers-helper';
import { CopyLinkService } from './app/services/copy-link.service';
import { SitesLoaderSvc } from './app/services/api.services/sites.loader.svc';
import { UserApiSvc } from './app/services/api.services/user.api.svc';
import { IncomingMessagesService } from './app/services/external/incoming-messages.service';
import { OutgoingMessagesService } from './app/services/external/outgoing-messages.service';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { NGXS_PLUGINS, NgxsModule } from '@ngxs/store';
import { cleanStorePlugin } from './app/Store/loadSitePlugin';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './app/cache-route-resuse.strategy';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpErrorInterceptor } from './app/Error/http-error.interceptor';
import { StatusService } from './app/services/status.service';
import { AuthGuard } from './app/Guards/Auth.guard';
import { TourAuthGuard } from './app/Guards/TourAuth.guard';
import { AlreadyLoggedGuard } from './app/Guards/Already-logged.guard';
import { DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './app/material.module';
import { SharedModule } from './app/shared.module';
import { AppState } from './app/Store/app.state/app.state';
import { SitesState } from './app/Store/sites.state/sites.state';
import { ZonesState } from './app/Store/zones.state/zones.state';
import { LayersState } from './app/Store/layers.state/layers.state';
import { ViewpointsState } from './app/Store/viewpoints.state/viewpoints.state';
import { ModelsState } from './app/Store/models.state/models.state';
import { PlacemarksState } from './app/Store/placemarks.state/placemarks.state';
import { SettingsState } from './app/Store/settings.state/settings.state';
import { DiscussionsState } from './app/Store/discussions.state/discussions.state';
import { UsersState } from './app/Store/user.state/users.state';
import { RolesState } from './app/Store/role.state/roles.state';
import { GoogleChartsModule } from 'angular-google-charts';
import { AppRouting } from './app/app.routing';
import { AppComponent } from './app/app.component';
import { AppTitleStrategy } from './app/services/app-title.strategy';
import { BaseTourState } from './app/Store/baseTour.state/baseTour.state';

const API_SERVICES = [
  ServerApi,
  SessionApiSvc,
  SseApiSvc,
  PlacemarksApiSvc,
  SitesApiSvc,
  Models3DApiSvc,
  Models2DApiSvc,
  FilesApiSvc,
  LayersApiSvc,
  ZonesApiSvc,
  ViewpointsApiSvc,
  TourApiSvc,
  DiscussionApiSvc,
  ImportExportApiSvc,
  SearchApiSvc,
  PermissionApiSvc,
  ScansApiSvc,
  WebshareApiSvc,
  WebshareLoginApiSvc,
  DispatcherSseApiSvc,
  TemplateManagementApiSvc,
  DataPrivacyApiSvc,
  MoveObjectApiSvc,
  BackgroundOperationsApiSvc,
  ThemeService,
  DownloadFileHelper
];
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(NgxPaginationModule, BrowserModule, FormsModule, ReactiveFormsModule, MaterialModule, SharedModule, NgxsModule.forRoot([
            AppState,
            SitesState,
            ZonesState,
            LayersState,
            ViewpointsState,
            ModelsState,
            PlacemarksState,
            SettingsState,
            DiscussionsState,
            UsersState,
            RolesState,
            BaseTourState
        ]), 
        // NgxsReduxDevtoolsPluginModule.forRoot(),
        PerfectScrollbarModule, GoogleChartsModule, AppRouting),
        ...API_SERVICES,
        SvgIconsService,
        DialogService,
        DialogComSvc,
        ObjectSiteValidatorService,
        Validators,
        LayersStateUtils,
        CmdRouterService,
        SitesUtils,
        LibIconsService,
        UserDetailsService,
        PlacemarkPreviewService,
        ContainersHelper,
        CopyLinkService,
        SitesLoaderSvc,
        UserApiSvc,
        IncomingMessagesService,
        OutgoingMessagesService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
            provide: NGXS_PLUGINS,
            useValue: cleanStorePlugin,
            multi: true
        },
        {
            provide: RouteReuseStrategy,
            useClass: CacheRouteReuseStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        StatusService,
        AuthGuard,
        TourAuthGuard,
        AlreadyLoggedGuard,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        { provide: TitleStrategy, useClass: AppTitleStrategy },
    ]
})
  .catch((err) => console.log(err));
